var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "legendForm",
              attrs: {
                model: _vm.legendForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("show"),
                      expression: "showProperty('show')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeLegendStyle("show")
                        },
                      },
                      model: {
                        value: _vm.legendForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.legendForm, "show", $$v)
                        },
                        expression: "legendForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.legendForm.show,
                      expression: "legendForm.show",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("icon"),
                          expression: "showProperty('icon')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.icon") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.icon") },
                          on: {
                            change: function ($event) {
                              return _vm.changeLegendStyle("icon")
                            },
                          },
                          model: {
                            value: _vm.legendForm.icon,
                            callback: function ($$v) {
                              _vm.$set(_vm.legendForm, "icon", $$v)
                            },
                            expression: "legendForm.icon",
                          },
                        },
                        _vm._l(_vm.iconSymbolOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("orient"),
                          expression: "showProperty('orient')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.orient") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeLegendStyle("orient")
                            },
                          },
                          model: {
                            value: _vm.legendForm.orient,
                            callback: function ($$v) {
                              _vm.$set(_vm.legendForm, "orient", $$v)
                            },
                            expression: "legendForm.orient",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "horizontal" } },
                            [_vm._v(_vm._s(_vm.$t("chart.horizontal")))]
                          ),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "vertical" } },
                            [_vm._v(_vm._s(_vm.$t("chart.vertical")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("textStyle"),
                          expression: "showProperty('textStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.text_fontsize"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLegendStyle("textStyle")
                            },
                          },
                          model: {
                            value: _vm.legendForm.textStyle.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.legendForm.textStyle,
                                "fontSize",
                                $$v
                              )
                            },
                            expression: "legendForm.textStyle.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("textStyle"),
                          expression: "showProperty('textStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeLegendStyle("textStyle")
                          },
                        },
                        model: {
                          value: _vm.legendForm.textStyle.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.legendForm.textStyle, "color", $$v)
                          },
                          expression: "legendForm.textStyle.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("hPosition"),
                          expression: "showProperty('hPosition')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_h_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeLegendStyle("hPosition")
                            },
                          },
                          model: {
                            value: _vm.legendForm.hPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.legendForm, "hPosition", $$v)
                            },
                            expression: "legendForm.hPosition",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_left"))),
                          ]),
                          _c(
                            "el-radio-button",
                            {
                              attrs: {
                                disabled: _vm.legendForm.vPosition === "center",
                                label: "center",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.text_pos_center")))]
                          ),
                          _c("el-radio-button", { attrs: { label: "right" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_right"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("vPosition"),
                          expression: "showProperty('vPosition')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_v_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeLegendStyle("vPosition")
                            },
                          },
                          model: {
                            value: _vm.legendForm.vPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.legendForm, "vPosition", $$v)
                            },
                            expression: "legendForm.vPosition",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "top" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_top"))),
                          ]),
                          _c(
                            "el-radio-button",
                            {
                              attrs: {
                                disabled: _vm.legendForm.hPosition === "center",
                                label: "center",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.text_pos_center")))]
                          ),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "bottom" } },
                            [_vm._v(_vm._s(_vm.$t("chart.text_pos_bottom")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }